import React, { useCallback, useEffect, useState } from 'react';
import './bulkUpdate.css';
import { tableFormat } from '../../../config/tableFormat';
import axios from 'axios';
import baseConfig from '../../../config/config';
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import Draggable from '../../components/tableComponent/tableComponent/Draggable';

const BulkUpdate = (props) => {
    const [selectedArray, setSelectedArray] = React.useState(props.data?.filter((item, index) => (props.selectedIndex?.includes(item.RequestID)))?.map((item) => ({
        RequestID: item.RequestID,
        RequestCode: item.RequestCode,
        RequestDate: item.RequestDate,
        CustomerName: item.CustomerName,
        RequestStatus: item.RequestStatus,
        FullyAllocatedDate: item.FullyAllocatedDate,
        DateNeeded: item.DateNeeded,
        GPU_Name: item.GPU_Name,
        GPUsRequested: item.GPUsRequested,
        DateAllocated: item.DateAllocated,
        GPUsAllocated: item.GPUsAllocated,
        RegionFlexibility: item.RegionFlexibility,
        RegionNeeded: item.RegionNeeded,
        GPUsOwed: item.GPUsOwed,
        LostToCompetitor: item.LostToCompetitor,
        UseCaseCategory: item.UseCaseCategory,
        UAT_ID: item.UAT_ID,
        TPID: item.TPID,
        RI: item.RI,
        EarmarkedDate: item.EarmarkedDate,
        Tag: item.Tag,
        AIGBB: item.AIGBB,
        DC_RegionAllocated: item.DC_RegionAllocated,
        LostReason: item.LostReason,
        LostToCompetitor: item.LostToCompetitor,
        UseCaseCategory: item.UseCaseCategory,
        MSX_Opportunity_ID: item.MSX_Opportunity_ID,
        MSX_Milestone_ID: item.MSX_Milestone_ID,
    })));
    const [isDateNeededSelected, setIsDateNeededSelected] = useState(false);
    const [isRequestDateSelected, setIsRequestDateSelected] = useState(false);
    const [isDateSelected, setIsDateSelected] = useState(false);
    const [propertySelected, setPropertySelected] = React.useState("")
    const [error, setError] = React.useState('');
    const [updateList, setUpdateList] = React.useState([]);
    const [readyList, setReadyList] = React.useState([]);
    const [updating, setUpdating] = React.useState(false);
    const [updationFailed, setUpdationFailed] = React.useState(false);
    const [updateSuccess, setUpdateSuccess] = React.useState(false)
    const currentTab = sessionStorage.getItem('tab');
    const bulkUpdateFormat = currentTab === '1' ? tableFormat.GPUsBulkUpdate : tableFormat.GPUsBulkUpdate;
    const RefferenceData = useSelector(store => store.distinctDataThroughSingleApi.distinctDataThroughSingleApi);
    const navigate = useNavigate();
    const handleInputChange = (key, value, property) => {
        setUpdateList({ key, value, property })
    }
    const riOption = useSelector((store) =>
      store.distinctDataThroughSingleApi.distinctDataThroughSingleApi.RI !==
      undefined
        ? store.distinctDataThroughSingleApi.distinctDataThroughSingleApi.RI?.map(
            (item) => ({
              Key: item["Value"],
              Value: item["Value"],
            })
          )
        : null
    );
    const handleAddToUpdateList = () => {
        if (propertySelected && updateList == null) return;
        if (updateList && updateList.property) {
            let tempList = readyList
            setUpdateList(null);
            const keyExists = tempList.findIndex(item => item.key === updateList.key);
            if (keyExists === -1) {
                tempList.push(updateList)
            }
            else {
                tempList[keyExists] = updateList;
            }
            setReadyList(tempList);
        }
        setPropertySelected("")
    }
    const update = async () => {
        setUpdating(true);
        let updatedJsonDataArray = selectedArray;
        const readyListData = {};
        readyList.forEach(item => {
            readyListData[item.key] = item;
        });

        const specialFields = ['TPID', 'UAT_ID', 'RequestCode', 'RegionFlexibility', 'CustomerName', 'DateNeeded', 'RI', 'RequestDate', 'GPU_Name', 'GPUsRequested', 'RegionNeeded', 'RequestStatus'];

        updatedJsonDataArray = updatedJsonDataArray.map((item) => {
            const updatedItem = { ...item };

            specialFields.forEach(field => {
                if (readyListData[field] && readyListData[field].value !== "NoChange") {
                    if (field === 'RequestStatus') {
                        updatedItem[field] = readyListData[field].property;
                    } else {
                        updatedItem[field] = readyListData[field].value;
                    }
                }
            });


            updatedItem.RequestID = item.RequestID;
            return updatedItem;
        });
        const formatDateToMMDDYYYY = (dateString) => {
            if (!dateString || dateString === "NoChange") return "";
            const [year, month, day] = dateString.split('-');
            if (!year || !month || !day) return "";
            return `${month}/${day}/${year}`;
        };

        const dataToSend = {
            Requests: updatedJsonDataArray.map(item => ({
                SplitFrom: 0,
                CustomerName: item.CustomerName || "",
                RequestStatus: item.RequestStatus || "",
                DateNeeded: isDateNeededSelected ? formatDateToMMDDYYYY(item.DateNeeded) : item.DateNeeded,
                RequestDate: isRequestDateSelected ? formatDateToMMDDYYYY(item.RequestDate) : item.RequestDate,
                GPU_Name: item.GPU_Name || "",
                GPUsRequested: item.GPUsRequested || 0,
                RegionNeeded: item.RegionNeeded || "",
                RegionFlexibility: item.RegionFlexibility || "" ,
                GPUsAllocated: item.GPUsAllocated || 0,
                DateAllocated: isDateSelected ? formatDateToMMDDYYYY(item.DateAllocated) : "",
                FullyAllocatedDate: item.FullyAllocatedDate || "",
                GPUsOwed: item.GPUsOwed || 0,
                UAT_ID: item.UAT_ID || "",
                TPID: item.TPID || "",
                RI: item.RI || "",
                DC_RegionAllocated: item.DC_RegionAllocated || "",
                RequestID: item.RequestID !== undefined && item.RequestID !== null ? item.RequestID : 0,
                GPUSplitted: item.GPUSplitted || [0],
                RequestCode: item.RequestCode || "",
                Tag: Array.isArray(item.Tag) ? item.Tag : (typeof item.Tag === 'string' ? item.Tag.split(',').map(tag => tag.trim()) : []),
                AIGBB: item.AIGBB || "",
                EarmarkedDate: item.EarmarkedDate || "",
                LostReason: item.LostReason || "",
                LostToCompetitor: item.LostToCompetitor || "",
                UseCaseCategory: item.UseCaseCategory || "",
                MSX_Opportunity_ID: item.MSX_Opportunity_ID || "",
                MSX_Milestone_ID: item.MSX_Milestone_ID || "",
            }))
        };
        try {
            let csrfToken=localStorage.getItem("csrfToken")

            const response = await axios.post(
                baseConfig.apiBaseUrl + '/request/bulk/update',
                dataToSend,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        "serviceid": sessionStorage.getItem("userToken"),
                        "X-CSRF-Token": csrfToken
                    },
                    withCredentials: true,
                }
            );

            if (response.status === 200) {
                setUpdating(false);
                setUpdateSuccess(true);
                setTimeout(() => {
                    setUpdateSuccess(false);
                    window.location.reload();
                }, 3000);
            }
        } catch (error) {
            console.error('API Error:', error);
            setUpdating(false);
            setUpdationFailed(true);
            setTimeout(() => {
                setUpdationFailed(false);
            }, 3000);
            if (error.response && error.response.status === 401) {
                navigate("/errorPage");
            }
        }
        finally {
            setUpdating(false);
        }
    };

    const setInputField = (propertySelected) => {
        let label = propertySelected;
        const RequestStatus = RefferenceData?.RequestStatus || [];
        if (propertySelected !== "") {
            if (sessionStorage.getItem('tab') === '1') {
                if (label === 'RequestDate' || label === 'DateNeeded') {
                    return (
                        <>
                            <div className="input-container">
                                <input
                                    type="date"
                                    onKeyDown={(event) => event.preventDefault()}
                                    className="custom-input-bulk"
                                    style={{ width: '34%' }}
                                    placeholder={`Enter ${(bulkUpdateFormat.find(item => item.key === label))?.label}`}
                                    value={updateList?.value}
                                    onChange={(event) => {
                                        if (label === 'RequestDate') {
                                            setIsRequestDateSelected(true);
                                        }
                                        if (label === 'DateNeeded') {
                                            setIsDateNeededSelected(true);
                                        }
                                        handleInputChange(label, event.target.value, event.target.value);
                                    }}
                                />
                            </div>
                        </>
                    );
                }
                if (label === 'RequestStatus' || label === 'GPU_Name' || label === 'RegionFlexibility' || label === 'RI') {
                    let options = [];
                    if (label === 'RequestStatus') {
                        options = RequestStatus;
                    } else if (label === 'GPU_Name') {
                        options = RefferenceData?.GPU || [];
                    }
                    else if (label === 'RI') {
                        options = riOption || [];
                    }
                    else if (label === 'RegionFlexibility') {
                        options = RefferenceData?.RegionFlexibility || "";
                    }
                    return (
                        <div className="input-container">
                            <select
                                className="select-container-bulk"
                                style={{ width: '34%' }}
                                onChange={(event) => {
                                    const selectedItem = options.find(item => item.Key === event.target.value);
                                    if (label === 'GPU_Name' || label === 'RequestStatus' || label === 'RegionFlexibility') {
                                        handleInputChange(label, selectedItem?.Value, selectedItem?.Value);
                                    } else {
                                        handleInputChange(label, event.target.value, selectedItem?.Value || '');
                                    }
                                }}
                            >
                                <option value="">
                                    Choose {(bulkUpdateFormat.find(item => item.key === label))?.label}
                                </option>
                                {options.length > 0 ? (
                                    options.map((item) => (
                                        <option key={item.Key} value={item.Key}>
                                            {item.Value}
                                        </option>
                                    ))
                                ) : (
                                    <option value="">No options available</option>
                                )}
                            </select>
                        </div>
                    );
                }

                if (label === 'CustomerName' || label === 'RequestCode' || label === 'GPUsRequested' || label === 'RegionNeeded' || label === 'RI' || label === 'UAT_ID' || label === 'TPID') {
                    return (
                        <div className="input-container">
                            <input
                                type="text"
                                className="custom-input-bulk"
                                style={{ width: '34%' }}
                                placeholder={`Enter ${(bulkUpdateFormat.find(item => item.key === label))?.label}`}
                                defaultValue=""
                                onChange={(event) => {
                                    const value = event.target.value;
                                    if (label === 'GPUsRequested') {
                                        const numericValue = Number(value);
                                        if (isNaN(numericValue) || !Number.isInteger(numericValue)) {
                                            setError('GPUs Requested must be an integer');
                                            return;
                                        }
                                        if (numericValue < 0) {
                                            setError('GPUs Requested cannot be negative');
                                        } else if (numericValue % 8 !== 0) {
                                            setError('GPUs Requested must be a multiple of 8');
                                        } else {
                                            setError('');
                                            handleInputChange(label, value, value);
                                        }
                                    } else {
                                        setError('');
                                        handleInputChange(label, value, value);
                                    }
                                }}
                            />
                            {label === 'GPUsRequested' && error && (
                                <div style={{ color: 'red', fontSize: '0.85rem', marginTop: '4px' }}>{error}</div>
                            )}
                        </div>
                    );
                }
            }

        } else {
            return (<></>);
        }
    };

    function isDate(dateString) {
        const regex = /^\d{4}-\d{2}-\d{2}$/;
        return regex.test(dateString);
    }

    function formatDate(dateString) {
        const parts = dateString.split('-');
        if (parts.length === 3) {
            const [year, month, day] = parts;
            return `${month}/${day}/${year}`;
        }
        return '';
    }

    const handleEscapeKeyPress = useCallback((event) => {
        if (event.key === 'Escape') {
            props.closeBulkUpdate()
        }
    }, []);

    useEffect(() => {
        document.addEventListener('keydown', handleEscapeKeyPress);

        return () => {
            document.removeEventListener('keydown', handleEscapeKeyPress);
        };
    }, [handleEscapeKeyPress]);

    return (
        <>
            <div className="modal-container">
                <div style={{ maxHeight: '100vh' }}>
                    <div className="title">
                        <b>Bulk Update</b>
                        <i className="fa fa-times close-icon"
                            onClick={props.closeBulkUpdate}
                        ></i>
                    </div>

                    <hr className="divider" />

                    <div className="text" style={{ fontSize: '13.5px' }}>
                        Choose the properties you wish to update from the list below and click on the 'Add to Update List' button. You can select multiple properties and add them to the update list. Once you've finished selecting the properties to update, click on the 'Update' button to apply your changes.
                    </div>

                    <div className="custom-modal">
                        <div className="left-panel">
                            <label className="text-container-bulk">Select Property</label>
                            <div className="select-container" style={{ marginTop: '15px' }}>
                                <select value={propertySelected} onChange={(event) => { setPropertySelected(event.target.value) }}>
                                    <option value={""}>Select Property</option>
                                    {bulkUpdateFormat.map((property) => (
                                        <option value={property.key}>{property.label}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="input-container-bulk">
                                <label className="text-container-bulk">{(bulkUpdateFormat.find(item => item.key === propertySelected))?.label}</label>
                                {setInputField(propertySelected)}
                            </div>

                            {propertySelected !== "" &&
                                <div className="container" style={{ paddingTop: '13vh' }}>
                                    <div className="button-container" onClick={(event) => { handleAddToUpdateList(event) }}>
                                        <button >Add to Update list</button>
                                    </div>
                                </div>
                            }
                        </div>

                        <div className="divider-vertical"></div>

                        <div className="right-panel">
                            <label className="text-container-bulk">List to Update</label>
                            <ul className="json-list">
                                {readyList.map((item, index) => (
                                    <li key={index} className="json-item">
                                        <span className="json-key">
                                            {(bulkUpdateFormat.find(properties => properties.key === item.key))?.label}
                                        </span>
                                        <span className={item.key === 'Tag' ? "json-value tag-json-value " : "json-value "}>
                                            {isDate(item.property) ? formatDate(item.property) :
                                                item.key === 'Tag' ? (
                                                    <>
                                                        <Draggable>
                                                            {item.property.length > 0 && item.property?.map((tag, tagIndex) =>
                                                                <span key={tagIndex} className="Tag">{tag.trim()}</span>
                                                            )}
                                                        </Draggable>
                                                        {item.property.length === 0 && (
                                                            <span key={index}>NA</span>
                                                        )}
                                                    </>
                                                ) : (

                                                    (
                                                        (
                                                            item.property
                                                        )
                                                    )
                                                )}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className="container">
                        <button
                            className="button button-go-back"
                            onClick={props.closeBulkUpdate}
                        >
                            Cancel
                        </button>
                        <div className="button-container">
                            <button disabled={updating ? true : false} onClick={() => { update() }}>Bulk Update</button>
                        </div>
                    </div>

                </div>
            </div >
            {updating && <div className="alert" style={{ backgroundColor: '#aaaa09' }}>
                Updating Requests...
            </div>}
            {updateSuccess && (
                <div className="alert" style={{ backgroundColor: '#4CAF50' }}>
                    Requests Updated successfully.
                </div>
            )}

            {updationFailed && <div className="alert">
                Failed To Update Requests
            </div>}
        </>
    );
};

export default BulkUpdate;